// NPM Imports
import React, { Component, Fragment } from "react";

// Components Imports
import RedoButton from "./RedoButton";
import UndoButton from "./UndoButton";
import InlineButtons from "./InlineButtons";
import ListButtons from "./ListButtons";
import HeaderButtons from "./HeaderButtons";
// import NormalTextButton from "./NormalTextButton";
import AlignButtons from "./AlignButtons";
import IdentButtons from "./IdentButtons";
import DynamicFieldButton from "./DynamicFieldButton";
import AddNote from "./AddNote";
import HyperlinkButton from "./HyperlinkButton";
import CustomColor from "./CustomColor";
import CustomSize from "./CustomSize";
import CustomFontStyle from "./CustomFontStyle";
import LineHeight from "./LineHeight";
import CustomTextHighlight from "./CustomTextHighlight";
import CustomizeDocBtn from "./CustomizeDocBtn";

// Internal Imports
import { DOCUMENTS } from "../../constants";
import {
  checkEmptySelection,
  checkSelectedTextHasEntity,
} from "../../utils/draftUtils";

// Destructuring
const { COMPONENT_FEATURE, DRAFT_ENTITY, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class RevvToolBar extends Component {
  state = {
    activeToolbarDropDown: null,
  };

  componentDidUpdate = (prevProps, nextProps) => {
    if (
      nextProps.activeToolbarDropDown === "FONT_COLOR" &&
      this.state.activeToolbarDropDown !== "FONT_COLOR"
    ) {
      this.props.handleCustomColorDropDownOpen(false, true);
    }
  };

  isNotesAllowed = (editorState, mode) => {
    if (!COMPONENT_FEATURE[mode].addNote) {
      return false;
    }
    if (checkEmptySelection(editorState)) {
      return false;
    }
    if (checkSelectedTextHasEntity(editorState, DRAFT_ENTITY.NOTES)) {
      return false;
    }
    return true;
  };

  isDynamicFieldAllowed = editorState => {
    // if (!COMPONENT_FEATURE[mode].dynamicFieldButton) {
    //   return false;
    // }
    if (checkEmptySelection(editorState)) {
      return false;
    }
    if (checkSelectedTextHasEntity(editorState, DRAFT_ENTITY.DYNAMICFIELD)) {
      return false;
    }
    return true;
  };

  isHyperLinkAllowed = (editorState, mode) => {
    if (!COMPONENT_FEATURE[mode].hyperlinkButton) {
      return false;
    }
    if (
      checkEmptySelection(editorState) ||
      checkSelectedTextHasEntity(editorState, DRAFT_ENTITY.DYNAMICFIELD)
    ) {
      return false;
    }

    return true;
  };

  _toogleToolbarDropDown = type => {
    this.setState({
      activeToolbarDropDown: type,
    });
  };

  render() {
    const {
      externalProps,
      mode,
      component,
      addNote,
      editorState,
      handleUndo,
      handleRedo,
      handleBIUButtonClick,
      handleListButton,
      handleHeaderButton,
      handleNormalText,
      handleAlignment,
      handleLineHeight,
      handleIndent,
      highlightSelection,
      removeHighlightSelection,
      showHyperlinkBox,
      closeHyperlinkBox,
      isSeparateToolbar,
      fontFamilyUpdate,
      isEditableTextAreaClauseOptionEditor,
      isEditableTablePlaceholderComponent,
      isTextEditable,
      isLocked,
      isSharedDocument,
    } = this.props;

    let hideToolbarForLinkedTable = true;
    if (
      component &&
      component.data &&
      component.data.attributes &&
      !component.data.attributes.editable
    ) {
      hideToolbarForLinkedTable = false;
    }

    let hideListButtons = false;
    if (
      component &&
      component.componentMeta &&
      component.componentMeta.componentType ===
        DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
    ) {
      hideListButtons = true;
    }

    const allowToSaveRecentStyles = !this.props.showForm && isSeparateToolbar;

    return (
      <div
        id="draft-custom-toolbar"
        className={`revvtoolbar-wrapper ${
          (isEditableTextAreaClauseOptionEditor ||
            isEditableTablePlaceholderComponent) &&
          this.props.showForm &&
          !editorState
            ? ""
            : ""
        } ${
          isLocked &&
          !isEditableTextAreaClauseOptionEditor &&
          !isEditableTablePlaceholderComponent &&
          !this.props.showForm
            ? " hide-revvtoolbar-wrapper"
            : ""
        }`}>
        {/* 1. Undo Toolbar button */}
        {(!isEditableTextAreaClauseOptionEditor ||
          !isEditableTablePlaceholderComponent) &&
          isSeparateToolbar &&
          COMPONENT_FEATURE[mode].allowUndo && (
            <UndoButton
              data-test="revvtoolbar-undo-button"
              {...externalProps}
              section={component}
              mode={mode}
              handleUndo={handleUndo}
            />
          )}

        {/* 2. Redo Toolbar button */}
        {(!isEditableTextAreaClauseOptionEditor ||
          !isEditableTablePlaceholderComponent) &&
          isSeparateToolbar &&
          COMPONENT_FEATURE[mode].allowUndo && (
            <RedoButton
              data-test="revvtoolbar-redo-button"
              {...externalProps}
              section={component}
              mode={mode}
              handleRedo={handleRedo}
            />
          )}
        <CustomizeDocBtn isSharedDocument={isSharedDocument} />

        {editorState &&
          component &&
          hideToolbarForLinkedTable &&
          isTextEditable && (
            <Fragment>
              {!isEditableTextAreaClauseOptionEditor &&
                !isEditableTablePlaceholderComponent &&
                isSeparateToolbar && <div className="line-divide" />}
              {/* 8. Header Toolbar buttons ex: H1, H2, H3 & H4 */}
              <HeaderButtons
                data-test="revvtoolbar-header-buttons"
                {...externalProps}
                editorState={editorState}
                handleHeaderButton={handleHeaderButton}
                handleNormalText={handleNormalText}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                saveMetaData={this.props.saveMetaData}
                metaData={this.props.metaData}
                handleChange={this.props.handleChange}
                handlePageNumber={this.props.handlePageNumber}
                isSeparateToolbar={isSeparateToolbar}
                allowToSaveRecentStyles={allowToSaveRecentStyles}
              />

              {/* 6. Custom Font Family INline Toolbar button */}
              <CustomFontStyle
                externalProps={externalProps}
                editorState={editorState}
                fontFamilyUpdate={fontFamilyUpdate}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                metaData={this.props.metaData}
                saveMetaData={this.props.saveMetaData}
                isEditableTextAreaClauseOptionEditor={
                  isEditableTextAreaClauseOptionEditor
                }
                isEditableTablePlaceholderComponent={
                  isEditableTablePlaceholderComponent
                }
                isSeparateToolbar={isSeparateToolbar}
                allowToSaveRecentStyles={allowToSaveRecentStyles}
                showForm={this.props.showForm}
                isSharedDocument={isSharedDocument}
              />
              <div className="line-divide" />
              {/* 4. Custom Font Size Inline Toolbar button */}
              <CustomSize
                externalProps={externalProps}
                editorState={editorState}
                sizeUpdate={handleBIUButtonClick}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                metaData={this.props.metaData}
                saveMetaData={this.props.saveMetaData}
              />
              <div className="line-divide" />
              {/* 3. Inline Toolbar buttons ex: BOLD, ITALIC & UNDERLINE */}
              <InlineButtons
                data-test="revvtoolbar-inline-buttons"
                externalProps={externalProps}
                editorState={editorState}
                handleButtonClick={handleBIUButtonClick}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                metaData={this.props.metaData}
              />
              <CustomColor
                externalProps={externalProps}
                editorState={editorState}
                fontColorUpdate={handleBIUButtonClick}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                preventEditorToDeactivate={this.props.preventEditorToDeactivate}
                handleCustomColorDropDownOpen={
                  this.props.handleCustomColorDropDownOpen
                }
                toolbarCustomColorDropdownRef={
                  this.props.toolbarCustomColorDropdownRef
                }
                metaData={this.props.metaData}
                saveMetaData={this.props.saveMetaData}
              />
              <CustomTextHighlight
                externalProps={externalProps}
                editorState={editorState}
                textHighlightUpdate={handleBIUButtonClick}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
                preventEditorToDeactivate={this.props.preventEditorToDeactivate}
                handleCustomColorDropDownOpen={
                  this.props.handleCustomColorDropDownOpen
                }
                toolbarCustomColorDropdownRef={
                  this.props.toolbarCustomColorDropdownRef
                }
                metaData={this.props.metaData}
                saveMetaData={this.props.saveMetaData}
              />
              <div className="line-divide" />

              {/* 10. Align Toolbar buttons ex: Left/Center/Right align */}
              <AlignButtons
                data-test="revvtoolbar-align-buttons"
                {...externalProps}
                editorState={editorState}
                handleAlignment={handleAlignment}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
              />
              <div className="line-divide" />
              <LineHeight
                editorState={editorState}
                // saveMetaData={this.props.saveMetaData}
                handleLineHeight={handleLineHeight}
                toogleToolbarDropDown={this.props.toogleToolbarDropDown}
                activeToolbarDropDown={this.props.activeToolbarDropDown}
              />
              <div className="line-divide" />
              {/* 7. List Toolbar buttons ex: Ordered/Unordered List */}

              {!hideListButtons && (
                <ListButtons
                  data-test="revvtoolbar-list-buttons"
                  {...externalProps}
                  editorState={editorState}
                  handleNormalText={handleNormalText}
                  handleListButton={handleListButton}
                />
              )}
              {!hideListButtons && <div className="line-divide" />}

              {/* 11. Ident Toolbar buttons ex: Indent/Outdent */}
              <IdentButtons
                data-test="revvtoolbar-ident-buttons"
                {...externalProps}
                handleIndent={handleIndent}
              />

              {!isEditableTextAreaClauseOptionEditor &&
                !isEditableTablePlaceholderComponent && (
                  <div className="line-divide" />
                )}

              {/* 12. Add Hyperlink Toolbar button */}
              {!isEditableTextAreaClauseOptionEditor &&
                !isEditableTablePlaceholderComponent &&
                this.isHyperLinkAllowed(editorState, mode) && (
                  <HyperlinkButton
                    data-test="revvtoolbar-hyperlink-button"
                    externalProps={externalProps}
                    component={component}
                    editorState={editorState}
                    showHyperlinkBox={showHyperlinkBox}
                    closeHyperlinkBox={closeHyperlinkBox}
                    preventEditorToDeactivate={
                      this.props.preventEditorToDeactivate
                    }
                    activeComponentMeta={this.props.activeComponentMeta}
                  />
                )}

              {/* 13. Add Note Toolbar button */}
              {!isEditableTextAreaClauseOptionEditor &&
                !isEditableTablePlaceholderComponent &&
                this.isNotesAllowed(editorState, mode) && (
                  <AddNote
                    {...externalProps}
                    component={component}
                    addNote={addNote}
                    editorState={editorState}
                    highlightSelection={highlightSelection}
                    removeHighlightSelection={removeHighlightSelection}
                  />
                )}

              {/* 14. Add DynamicField Toolbar button */}
              {COMPONENT_FEATURE[mode].dynamicFieldButton && (
                <DynamicFieldButton
                  data-test="revvtoolbar-dynamic-field-button"
                  {...externalProps}
                  component={component}
                  editorState={editorState}
                  highlightSelection={highlightSelection}
                  removeHighlightSelection={removeHighlightSelection}
                  isDynamicFieldAllowed={this.isDynamicFieldAllowed}
                />
              )}
            </Fragment>
          )}
      </div>
    );
  }
}

export default RevvToolBar;
